import { Switch, VStack } from '@chakra-ui/react';
import { PriceMatchSettings } from '../../hooks/useGetSettings';
import { useSettingsDraft } from '../../pages/settings/SettingsDraftContext';
import { SettingsCard, SettingsRow } from './primitives';

interface EMSProps {
    data: PriceMatchSettings;
}

const EMS = ({ data }: EMSProps) => {
    // Edits are buffered on the shared settings draft, so the page's save bar
    // writes them alongside anything else the user changed on this screen.
    const { getDomain, setDomain } = useSettingsDraft();
    const priceMatching = getDomain('priceMatching', data) ?? data;

    const handleToggle = (key: keyof PriceMatchSettings, value: boolean) => {
        setDomain('priceMatching', { ...priceMatching, [key]: value });
    };

    return (
        <VStack spacing={6} align="stretch" pb={16}>
            <SettingsCard
                title="EMS exports"
                description="Configure how EMS is sent from your estimating system to your marketplaces."
            >
                <SettingsRow
                    label="Auto send"
                    description="When enabled, Yaxle will automatically send all EMS pushes directly to the connected marketplaces."
                    control={
                        <Switch
                            size="lg"
                            isChecked={priceMatching.autoPriceMatch}
                            onChange={(e) => handleToggle('autoPriceMatch', e.target.checked)}
                            colorScheme="partbay-blue"
                        />
                    }
                />
            </SettingsCard>
        </VStack>
    );
};

export default EMS;
